var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el-visor-pdf",staticClass:"_df_custom",attrs:{"webgl":"false","download":"false","source":_vm.source}})}
var staticRenderFns = []

export { render, staticRenderFns }